import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import APIClient from '../common/ApiClient'
import { ToastContainer, toast } from "react-toastify";
import SearchIcon from '@mui/icons-material/Search';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import AttachEmailIcon from '@mui/icons-material/AttachEmail';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import ListIcon from '@mui/icons-material/List';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import FilePresentIcon from '@mui/icons-material/FilePresent';
import ClearIcon from '@mui/icons-material/Clear';
import CheckIcon from '@mui/icons-material/Check';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

const NoticeList = () => {
    const location = useLocation();
    const [pageData, setPageData] = useState(null);
    const [tableColumns, setTableColumns] = useState(null);

    const [noticeType, setNoticeType] = useState('');
    const [noticeStatus, setNoticeStatus] = useState('');
    const [emailApplicable, setEmailApplicable] = useState('');
    const [whatsappApplicable, setWhatsappApplicable] = useState('');
    const [phone, setPhone] = useState('');
    const [sname, setSname] = useState('');
    const [actionButtonEnabled, setActionButtonEnabled] = useState('NA');
    const [selectedLot, setSelectedLot] = useState('');
    const [selectedSubProduct, setSelectedSubProduct] = useState('');

    const allLots = Array.from({ length: 15 }, (_, i) => `LOT-${i + 1}`);

    var selectedProduct = '', selectedStatus = '';
    const processKeyFromUrl = () => {
        var parameters = location.pathname.split('=')[1];
        if (parameters) {
            if (parameters.indexOf('-') != -1) {
                selectedProduct = parameters.split('-')[0];
                selectedStatus = parameters.split('-')[1];
            } else {
                selectedProduct = parameters;
                selectedStatus = '';
            }

            setNoticeType(selectedProduct);
            setNoticeStatus(selectedStatus);
            setActionButtonEnabled(selectedStatus);
        }
    };
    useEffect(() => {
        processKeyFromUrl();
        getData(selectedProduct, selectedStatus);
    }, []);
    const getData = (nType, nStatus) => {

        const sMonth = localStorage.getItem('month');
        const sYear = localStorage.getItem('year');
        if (nType === 'LRNCC') {
            APIClient.get('/noticeByFilterLRNCC', {
                params: {
                    noticeStatus: nStatus,
                    name: sname,
                    mobile: phone,
                    month: sMonth,
                    year: sYear,
                    lot: selectedLot,
                    email_required: emailApplicable,
                    wa_required: whatsappApplicable
                }
            }).then(response => {
                var odData = response.data.results;
                if (odData.length > 0) {
                    const sortedData = [...odData].sort((a, b) => {
                        return a.SrNo - b.SrNo;
                    });
                    odData = sortedData;
                }
                setPageData(odData);
                const keys = Object.keys(odData.length ? odData[0] : {});
                setTableColumns(keys);
            }).catch(error => {
                if (error.response) {
                    toast.error(error.response.data.message, {
                        position: "bottom-center",
                        pauseOnHover: true
                    });
                } else {
                    toast.error(error.message, {
                        position: "bottom-center",
                        pauseOnHover: true
                    });
                }
            });
        } else if (nType === 'SEC25CC') {
            APIClient.get('/noticeByFilterSEC25CC', {
                params: {
                    noticeStatus: nStatus,
                    name: sname,
                    mobile: phone,
                    month: sMonth,
                    year: sYear,
                    email_required: emailApplicable,
                    wa_required: whatsappApplicable
                }
            }).then(response => {
                var odData = response.data.results;
                if (odData.length > 0) {
                    const sortedData = [...odData].sort((a, b) => {
                        return a.SrNo - b.SrNo;
                    });
                    odData = sortedData;
                }
                setPageData(odData);
                const keys = Object.keys(odData.length ? odData[0] : {});
                setTableColumns(keys);
            }).catch(error => {
                if (error.response) {
                    toast.error(error.response.data.message, {
                        position: "bottom-center",
                        pauseOnHover: true
                    });
                } else {
                    toast.error(error.message, {
                        position: "bottom-center",
                        pauseOnHover: true
                    });
                }
            });
        } else if (nType === 'CC' && selectedSubProduct != "") {
            APIClient.get('/noticeByFilterCC', {
                params: {
                    noticeStatus: nStatus,
                    name: sname,
                    mobile: phone,
                    month: sMonth,
                    year: sYear,
                    sub_product: selectedSubProduct
                }
            }).then(response => {
                setPageData(response.data.results);
                const keys = Object.keys(response.data.results.length ? response.data.results[0] : {});
                setTableColumns(keys);
                // toast.success(response.data.message, {
                //     position: "bottom-center",
                //     pauseOnHover: true,
                //     delay: true
                // });
            }).catch(error => {
                if (error.response) {
                    toast.error(error.response.data.message, {
                        position: "bottom-center",
                        pauseOnHover: true
                    });
                } else {
                    toast.error(error.message, {
                        position: "bottom-center",
                        pauseOnHover: true
                    });
                }
            });
        } else {
            APIClient.get('/noticeByFilter', {
                params: {
                    noticeType: nType,
                    noticeStatus: nStatus,
                    name: sname,
                    mobile: phone,
                    month: sMonth,
                    year: sYear,
                }
            }).then(response => {
                setPageData(response.data.results);
                const keys = Object.keys(response.data.results.length ? response.data.results[0] : {});
                setTableColumns(keys);
                // toast.success(response.data.message, {
                //     position: "bottom-center",
                //     pauseOnHover: true,
                //     delay: true
                // });
            }).catch(error => {
                if (error.response) {
                    toast.error(error.response.data.message, {
                        position: "bottom-center",
                        pauseOnHover: true
                    });
                } else {
                    toast.error(error.message, {
                        position: "bottom-center",
                        pauseOnHover: true
                    });
                }
            });
        }
    }
    const handleSearch = () => {
        getData(noticeType, noticeStatus);
    };
    const onAction = (sAction) => {
        if (sAction == "SW") {
            _sendWA();
        } else if (sAction == "SE") {
            _sendEmail();
        }
    }
    const _sendEmail = () => {
        if (pageData.length > 0) {

            var aEmailData = [];
            const sMonth = localStorage.getItem('month');
            const sYear = localStorage.getItem('year');
            var sUrl = '';
            if (noticeType === 'LRNCC') {
                sUrl = '/sendMailLRNCC';
                for (var i = 0; i < pageData.length; i++) {
                    var record = {};
                    record.srno = pageData[i]["SrNo"];
                    record.mask_card = pageData[i]["Mask Card"];
                    record.lot = pageData[i]["LOT"];
                    record.aan = pageData[i]["Aan"];
                    record.customer_name = pageData[i]["Name"];
                    record.current_address = pageData[i]["Current Address"];
                    record.permanent_address = pageData[i]["Permanent Address"];
                    record.office_address = pageData[i]["Office Address"];
                    record.alternet_address = pageData[i]["Alternet Address"];
                    record.balance = pageData[i]["Balance"];
                    record.notice_date = pageData[i]["Notice Date"];
                    record.clm_name = pageData[i]["CLM Name"];
                    record.clm_no = pageData[i]["CLM No"];
                    record.email = pageData[i]["Email"];
                    record.mobile = pageData[i]["Mobile"];
                    record.smonth = sMonth;
                    record.syear = sYear;
                    aEmailData.push(record);
                }
            } else if (noticeType === 'SEC25CC') {
                sUrl = '/sendMailSEC25CC';
                for (var i = 0; i < pageData.length; i++) {
                    var record = {};
                    record.ref_no = pageData[i]["Ref No"];
                    record.mask_card = pageData[i]["Mask Card"];
                    record.aan = pageData[i]["Aan"];
                    record.customer_name = pageData[i]["Name"];
                    record.product = pageData[i]["Product"];
                    record.account_no = pageData[i]["Account No"];
                    record.current_address = pageData[i]["Current Address"];
                    record.permanent_address = pageData[i]["Permanent Address"];
                    record.office_address = pageData[i]["Office Address"];
                    record.alternet_address = pageData[i]["Alternet Address"];
                    record.balance = pageData[i]["Balance"];
                    record.bounce_date = pageData[i]["Bounce Date"];
                    record.bounce_reason = pageData[i]["Bounce Reason"];
                    record.amount_word = pageData[i]["Amount Word"];
                    record.notice_date = pageData[i]["Notice Date"];
                    record.clm_name = pageData[i]["CLM Name"];
                    record.clm_no = pageData[i]["CLM No"];
                    record.email = pageData[i]["Email"];
                    record.mobile = pageData[i]["Mobile"];
                    record.smonth = sMonth;
                    record.syear = sYear;
                    aEmailData.push(record);
                }
            } else if (noticeType === 'CC') {
                sUrl = '/sendMailCC';
                for (var i = 0; i < pageData.length; i++) {
                    var record = {};
                    record.ref_no = pageData[i]["Ref No"];
                    record.name = pageData[i]["Name"];
                    record.short_product = pageData[i]["Short Product"];
                    record.aan = pageData[i]["AAN"];
                    record.masked_card_no = pageData[i]["Mask Card"];
                    record.address = pageData[i]["Address"];
                    record.notice_date = pageData[i]["Notice Date"];
                    record.email = pageData[i]["Email"];
                    record.mobile = pageData[i]["Mobile"];
                    record.bounce_date = pageData[i]["Bounce Date"];
                    record.bounce_amount = pageData[i]["Bounce Amount"];
                    record.clm_name = pageData[i]["CLM Name"];
                    record.clm_no = pageData[i]["CLM No"];
                    record.smonth = sMonth;
                    record.syear = sYear;
                    aEmailData.push(record);
                }
            } else {
                sUrl = '/sendMail';
                for (var i = 0; i < pageData.length; i++) {
                    var record = {};
                    record.ref_no = pageData[i]["Ref No."];
                    record.masked_card_no = pageData[i]["Masked Card No"];
                    record.address = pageData[i]["Address"];
                    record.aan16 = pageData[i]["Aan16"];
                    record.clm_name = pageData[i]["CLM Name"];
                    record.clm_no = pageData[i]["CLM No"];
                    record.email = pageData[i]["Email"];
                    record.mobile = pageData[i]["Mobile"];
                    record.bounce_date = pageData[i]["Bounce Date"];
                    record.bounce_amount = pageData[i]["Bounce Amount"];
                    record.name = pageData[i]["Name"];
                    record.smonth = sMonth;
                    record.syear = sYear;
                    aEmailData.push(record);
                }
            }
            APIClient.post(sUrl, aEmailData).then(response => {
                toast.success(response.data.message, {
                    position: "bottom-center",
                    pauseOnHover: true,
                    delay: true
                });
                handleSearch();
            }).catch(error => {
                toast.error(error.response.data.message, {
                    position: "bottom-center",
                    pauseOnHover: true
                });
            });
        } else {
            toast.info('No records found to send Email', {
                position: "bottom-center",
                pauseOnHover: true
            });
        }
    }
    const _sendWA_hold = () => {
        if (pageData && pageData.length > 0) {
            var aWAData = [];
            const sMonth = localStorage.getItem('month');
            const sYear = localStorage.getItem('year');
            var sUrl = '';
            if (noticeType === 'LRNCC') {
                sUrl = '/sendWaLRNCCNew';
                var isWAApplicable = false;
                if (pageData.length > 0) {
                    var record = {};
                    record.smonth = sMonth;
                    record.syear = sYear;
                    record.notice_type = noticeType;
                    aWAData = record; //.push(record);
                } else {
                    toast.info('No records found.', {
                        position: "bottom-center",
                        pauseOnHover: true,
                        delay: true
                    });
                    return;
                }
            } else if (noticeType === 'CC') {
                sUrl = '/sendWa';
                for (var i = 0; i < pageData.length; i++) {
                    var record = {};
                    record.ref_no = pageData[i]["Ref No."];
                    record.aan16 = pageData[i]["Aan16"];
                    record.smonth = sMonth;
                    record.syear = sYear;
                    aWAData.push(record);
                }
            }
            APIClient.post(sUrl, aWAData).then(response => {
                if (response.data.status == "error") {
                    toast.error(response.data.message, {
                        position: "bottom-center",
                        pauseOnHover: true,
                        delay: true
                    });
                } else {
                    toast.success(response.data.message, {
                        position: "bottom-center",
                        pauseOnHover: true,
                        delay: true
                    });
                }
                handleSearch();
            }).catch(error => {
                if (error.response) {
                    toast.error('API Failed! ' + error.response.data.message, {
                        position: "bottom-center",
                        pauseOnHover: true
                    });
                } else {
                    toast.error(error.message, {
                        position: "bottom-center",
                        pauseOnHover: true
                    });
                }
            });

        } else {
            toast.info('No Data to send WhatsApp', {
                position: "bottom-center",
                pauseOnHover: true
            });
        }
    }
    const _sendWA = () => {
        if (pageData && pageData.length > 0) {
            var aWAData = [];
            const sMonth = localStorage.getItem('month');
            const sYear = localStorage.getItem('year');
            var sUrl = '';
            if (noticeType === 'LRNCC') {
                sUrl = '/sendWaLRNCC';
                var isWAApplicable = false;
                for (var i = 0; i < pageData.length; i++) {
                    var record = {};
                    if (pageData[i]["WhatsApp Required?"] === 'Yes') {
                        isWAApplicable = true;
                        record.mask_card = pageData[i]["Mask Card"];
                        record.aan = pageData[i]["Aan"];
                        record.mobile = pageData[i]["Mobile"];
                        record.name = pageData[i]["Name"];
                        record.clm_name = pageData[i]["CLM Name"];
                        record.clm_no = pageData[i]["CLM No"];
                        record.smonth = sMonth;
                        record.syear = sYear;
                        aWAData.push(record);
                    }
                }
                if (isWAApplicable === false) {
                    toast.info('WhatsApp not required for the selected records.', {
                        position: "bottom-center",
                        pauseOnHover: true,
                        delay: true
                    });
                    return;
                }
            } else if (noticeType === 'SEC25CC') {
                sUrl = '/sendWaSEC25CC';
                var isWAApplicable = false;
                for (var i = 0; i < pageData.length; i++) {
                    var record = {};
                    if (pageData[i]["WhatsApp Required?"] === 'Yes') {
                        isWAApplicable = true;
                        record.mask_card = pageData[i]["Mask Card"];
                        record.aan = pageData[i]["Aan"];
                        record.mobile = pageData[i]["Mobile"];
                        record.name = pageData[i]["Name"];
                        record.balance = pageData[i]["Balance"];
                        record.clm_name = pageData[i]["CLM Name"];
                        record.clm_no = pageData[i]["CLM No"];
                        record.smonth = sMonth;
                        record.syear = sYear;
                        aWAData.push(record);
                    }
                }
                if (isWAApplicable === false) {
                    toast.info('WhatsApp not required for the selected records.', {
                        position: "bottom-center",
                        pauseOnHover: true,
                        delay: true
                    });
                    return;
                }
            } else if (noticeType === 'CC') {
                sUrl = '/sendWaCC';
                for (var i = 0; i < pageData.length; i++) {
                    var record = {};
                    record.name = pageData[i]["Name"];
                    record.short_product = pageData[i]["Short Product"];
                    record.aan = pageData[i]["AAN"];
                    record.masked_card_no = pageData[i]["Mask Card"];
                    record.mobile = pageData[i]["Mobile"];
                    record.bounce_amount = pageData[i]["Bounce Amount"];
                    record.clm_name = pageData[i]["CLM Name"];
                    record.clm_no = pageData[i]["CLM No"];
                    record.smonth = sMonth;
                    record.syear = sYear;
                    aWAData.push(record);
                }
            } else {
                sUrl = '/sendWa';
                for (var i = 0; i < pageData.length; i++) {
                    var record = {};
                    record.ref_no = pageData[i]["Ref No."];
                    record.aan16 = pageData[i]["Aan16"];
                    record.smonth = sMonth;
                    record.syear = sYear;
                    aWAData.push(record);
                }
            }
            APIClient.post(sUrl, aWAData).then(response => {
                if (response.data.status == "error") {
                    toast.error(response.data.message, {
                        position: "bottom-center",
                        pauseOnHover: true,
                        delay: true
                    });
                } else {
                    toast.success(response.data.message, {
                        position: "bottom-center",
                        pauseOnHover: true,
                        delay: true
                    });
                }
                handleSearch();
            }).catch(error => {
                if (error.response) {
                    toast.error('API Failed! ' + error.response.data.message, {
                        position: "bottom-center",
                        pauseOnHover: true
                    });
                } else {
                    toast.error(error.message, {
                        position: "bottom-center",
                        pauseOnHover: true
                    });
                }
            });

        } else {
            toast.info('No Data to send WhatsApp', {
                position: "bottom-center",
                pauseOnHover: true
            });
        }
    }
    const onStatusChange = (oEvent) => {
        setNoticeStatus(oEvent.target.value);
        setActionButtonEnabled(oEvent.target.value);
        getData(noticeType, oEvent.target.value);
    }
    const onProductChange = (oEvent) => {
        setNoticeType(oEvent.target.value);
        getData(oEvent.target.value, noticeStatus);
    }
    const onViewPDF = (oItem) => {
        const sMonth = localStorage.getItem('month');
        const sYear = localStorage.getItem('year');
        var _fileName = '', sUrl = '';
        if (noticeType === 'LRNCC') {
            sUrl = 'getPdfLRNCC';
            _fileName = 'LRN_CC_' + oItem.Aan + "_" + sMonth + "_" + sYear + ".pdf";// 0001010030000318777_December_2024.pdf";
        } else if (noticeType === 'SEC25CC') {
            sUrl = 'getPdfSec25CC';
            _fileName = 'SEC25_CC_' + oItem.Aan + "_" + sMonth + "_" + sYear + ".pdf";// 0001010030000318777_December_2024.pdf";
        } else if (noticeType === 'CC') {
            sUrl = 'getPdfCC';
            _fileName = "CC_" + oItem['Short Product'] + "_" + oItem.AAN + "_" + sMonth + "_" + sYear + ".pdf";// 0001010030000318777_December_2024.pdf";
        } else {
            sUrl = 'getPdf';
            _fileName = oItem.Aan16 + "_" + sMonth + "_" + sYear + ".pdf";// 0001010030000318777_December_2024.pdf";
        }

        APIClient.get(sUrl, {
            params: {
                fileName: _fileName
            },
            responseType: 'arraybuffer'
        }).then(response => {
            const pdfBlob = new Blob([response.data], { type: 'application/pdf' });
            const pdfUrl = URL.createObjectURL(pdfBlob);
            window.open(pdfUrl, '_blank');
        }).catch(error => {
            if (error.response.status === 404) {
                toast.error("File: " + _fileName + " not found.", {
                    position: "bottom-center",
                    pauseOnHover: true
                });
            } else {
                toast.error("Error while getting file", {
                    position: "bottom-center",
                    pauseOnHover: true
                });
            }
        });
    }
    const onExport = () => {
        if (pageData.length > 0) {
            if (noticeType === 'CC' && selectedSubProduct === "OTS") {
                const sMonth = localStorage.getItem('month');
                const sYear = localStorage.getItem('year');
                for (var i = 0; i < pageData.length; i++) {
                    pageData[i]["PDF Generated?"] = pageData[i]["PDF Generated?"] === 'X' ? 'Yes' : 'No';
                    pageData[i]["Email Sent?"] = pageData[i]["Email Sent?"] === 'X' ? 'Yes' : 'No';
                    pageData[i]["WhatsApp Sent?"] = pageData[i]["WhatsApp Sent?"] === 'X' ? 'Yes' : 'No';
                }
                const fileName = 'CC_' + selectedSubProduct + '_' + sMonth + '_' + sYear;
                const worksheet = XLSX.utils.json_to_sheet(pageData);

                // Add a new column header for "Link"
                const headers = XLSX.utils.sheet_to_json(worksheet, { header: 1 })[0];
                headers.push('PDF Link');
                XLSX.utils.sheet_add_aoa(worksheet, [headers], { origin: 'A1' });

                // Add HYPERLINK formula for each row in the "Link" column
                pageData.forEach((item, index) => {
                    const row = index + 2; // +2 to account for header row and 1-based indexing
                    const cellAddress = `R${row}`; // Assuming Link is the 4th column (adjust if needed)
                    //First way
                    // //while develop
                    // worksheet[cellAddress] = {
                    //     f: `HYPERLINK("http://localhost:5000/pdf/creditcards/CC_${selectedSubProduct}_${item["AAN"]}_${sMonth}_${sYear}.pdf", "View PDF")`,
                    // };
                    //While deployment
                    worksheet[cellAddress] = {
                        f: `HYPERLINK("https://chalkeassociates.com/pdfs/creditcards/CC_${selectedSubProduct}_${item["AAN"]}_${sMonth}_${sYear}.pdf", "View PDF")`,
                    };
                    ////Second way
                    // const url = `https://chalkeassociates.com/pdfs/${item["Aan16"]}_${sMonth}_${sYear}.pdf`;
                    // worksheet[cellAddress] = {
                    //     v: "Click to View", // Display text
                    //     l: { Target: url }, // Hyperlink URL
                    //     s: {
                    //         font: {
                    //             color: { rgb: "0000FF" }, // Blue color
                    //             underline: true, // Underline text
                    //         },
                    //     },
                    // };
                });

                // Create workbook and add the worksheet
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

                // Generate Excel file buffer
                const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

                // Create Blob for download
                const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
                saveAs(data, `${fileName}.xlsx`);
            } else if (noticeType === 'LRNCC') {
                const sMonth = localStorage.getItem('month');
                const sYear = localStorage.getItem('year');
                for (var i = 0; i < pageData.length; i++) {
                    pageData[i]["PDF Generated?"] = pageData[i]["PDF Generated?"] === 'X' ? 'Yes' : 'No';
                    pageData[i]["Email Sent?"] = pageData[i]["Email Sent?"] === 'X' ? 'Yes' : 'No';
                    pageData[i]["WhatsApp Sent?"] = pageData[i]["WhatsApp Sent?"] === 'X' ? 'Yes' : 'No';
                }
                const fileName = 'LRNCC_Notices_' + sMonth + '_' + sYear;
                const worksheet = XLSX.utils.json_to_sheet(pageData);

                // Add a new column header for "Link"
                const headers = XLSX.utils.sheet_to_json(worksheet, { header: 1 })[0];
                headers.push('PDF Link');
                XLSX.utils.sheet_add_aoa(worksheet, [headers], { origin: 'A1' });

                // Add HYPERLINK formula for each row in the "Link" column
                pageData.forEach((item, index) => {
                    const row = index + 2; // +2 to account for header row and 1-based indexing
                    const cellAddress = `V${row}`; // Assuming Link is the 4th column (adjust if needed)
                    //First way
                    //while develop
                    // worksheet[cellAddress] = {
                    //     f: `HYPERLINK("http://localhost:5000/pdf/lrn_cc/LRN_CC_${item["Aan"]}_${sMonth}_${sYear}.pdf", "View PDF")`,
                    // };
                    //While deployment
                    worksheet[cellAddress] = {
                        f: `HYPERLINK("https://chalkeassociates.com/pdfs/lrn_cc/LRN_CC_${item["Aan"]}_${sMonth}_${sYear}.pdf", "View PDF")`,
                    };
                });

                // Create workbook and add the worksheet
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

                // Generate Excel file buffer
                const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

                // Create Blob for download
                const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
                saveAs(data, `${fileName}.xlsx`);
            } else if (noticeType === 'SEC25CC') {
                const sMonth = localStorage.getItem('month');
                const sYear = localStorage.getItem('year');
                for (var i = 0; i < pageData.length; i++) {
                    pageData[i]["PDF Generated?"] = pageData[i]["PDF Generated?"] === 'X' ? 'Yes' : 'No';
                    pageData[i]["Email Sent?"] = pageData[i]["Email Sent?"] === 'X' ? 'Yes' : 'No';
                    pageData[i]["WhatsApp Sent?"] = pageData[i]["WhatsApp Sent?"] === 'X' ? 'Yes' : 'No';
                }
                const fileName = 'Sec25_CC_Notices_' + sMonth + '_' + sYear;
                const worksheet = XLSX.utils.json_to_sheet(pageData);

                // Add a new column header for "Link"
                const headers = XLSX.utils.sheet_to_json(worksheet, { header: 1 })[0];
                headers.push('PDF Link');
                XLSX.utils.sheet_add_aoa(worksheet, [headers], { origin: 'A1' });

                // Add HYPERLINK formula for each row in the "Link" column
                pageData.forEach((item, index) => {
                    const row = index + 2; // +2 to account for header row and 1-based indexing
                    const cellAddress = `Z${row}`; // Assuming Link is the 4th column (adjust if needed)
                    //First way
                    // //while develop
                    // worksheet[cellAddress] = {
                    //     f: `HYPERLINK("http://localhost:5000/pdf/sec25_cc/SEC25_CC_${item["Aan"]}_${sMonth}_${sYear}.pdf", "View PDF")`,
                    // };
                    // While deployment
                    worksheet[cellAddress] = {
                        f: `HYPERLINK("https://chalkeassociates.com/pdfs/sec25_cc/SEC25_CC_${item["Aan"]}_${sMonth}_${sYear}.pdf", "View PDF")`,
                    };
                });

                // Create workbook and add the worksheet
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

                // Generate Excel file buffer
                const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

                // Create Blob for download
                const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
                saveAs(data, `${fileName}.xlsx`);
            } else {
            toast.info('Notice type not found to export excel', {
                position: "bottom-center",
                pauseOnHover: true
            });
        }
        } else {
            toast.info('No records found to export excel', {
                position: "bottom-center",
                pauseOnHover: true
            });
        }
    }

    return <div className='childPage'>
        <div>
            <header style={{ padding: '10px', backgroundColor: '#f4f4f4', border: 'solid 1px #e7e2e2', marginBottom: '20px', borderRadius: '5px' }}>

                <div className='hBox'>
                    <div>
                        <label htmlFor="idType" style={{ display: 'block', marginBottom: '5px' }}>Product</label>

                        <select style={{ width: '100%' }} value={noticeType} onChange={onProductChange} >
                            <option value="">Select Product</option>
                            <option value="CC">Credit Card</option>
                            <option value="LRNCC">LRN - Credit Card</option>
                            <option value="SEC25CC">Section 25 - Credit Card</option>
                            <option value="HL" disabled>Home Loan</option>
                            <option value="PL" disabled>Personal Lonal</option>
                        </select>
                    </div>
                    {noticeType === 'CC' &&
                        <div>
                            <label style={{ display: 'block', marginBottom: '5px' }}>Sub-Product</label>
                            <select style={{ width: '100%' }} value={selectedSubProduct} onChange={(e) => setSelectedSubProduct(e.target.value)}>
                                <option value="">Select Product</option>
                                <option value="OTS">OTS</option>
                                <option value="OTS" disabled>BSN</option>
                                <option value="OTS" disabled>CIBIL</option>
                                <option value="OTS" disabled>Concilation</option>
                                <option value="OTS" disabled>CCML-ABUSE</option>
                                <option value="OTS" disabled>DECEASED-LH</option>
                                <option value="OTS" disabled>DNC-WO</option>
                                <option value="OTS" disabled>DNC-CF</option>
                                <option value="OTS" disabled>DLN notice</option>
                            </select>
                        </div>
                    }
                    <div>
                        <label htmlFor="idNoticeStatus" style={{ display: 'block', marginBottom: '5px' }}>Status</label>
                        <select style={{ width: '100%' }} value={noticeStatus} onChange={onStatusChange} >
                            <option value="">Select Status</option>
                            <option value="PG">PDF Generated</option>
                            <option value="ES">Email Sent</option>
                            <option value="MS">WhatsApp Send</option>
                            <option value="PF">Pending PDF</option>
                            <option value="PE">Pending Email</option>
                            <option value="PW">Pending WhatsApp</option>
                        </select>
                    </div>

                    <div>
                        <label htmlFor="idSname" style={{ display: 'block', marginBottom: '5px' }}>Name</label>
                        <input
                            id="idSname"
                            type="text"
                            placeholder="Search by Name"
                            value={sname}
                            onChange={(e) => setSname(e.target.value)}
                        />
                    </div>
                    <div>
                        <label htmlFor="idPhone" style={{ display: 'block', marginBottom: '5px' }}>Mobile</label>
                        <input
                            id="idPhone"
                            type="text"
                            placeholder="Search by Mobile No."
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                        />
                    </div>

                    {noticeType === 'LRNCC' &&
                        <div>
                            <label htmlFor="idSLot" style={{ display: 'block', marginBottom: '5px' }}>LOT</label>
                            <select id="idSLot" value={selectedLot} onChange={(e) => setSelectedLot(e.target.value)}>
                                <option value="">LOT</option>
                                {allLots.map((lot) => (
                                    <option ey={lot} value={lot}>
                                        {lot}
                                    </option>
                                ))}
                            </select>
                        </div>
                    }
                    {(noticeType === 'LRNCC' || noticeType === 'SEC25CC') &&
                        <div>
                            <label style={{ display: 'block', marginBottom: '5px' }}>Email Required</label>
                            <select style={{ width: '100%' }} value={emailApplicable} onChange={(e) => setEmailApplicable(e.target.value)} >
                                <option value="">Select</option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>
                        </div>
                    }
                    {(noticeType === 'LRNCC' || noticeType === 'SEC25CC') &&
                        <div>
                            <label style={{ display: 'block', marginBottom: '5px' }}>WhatsApp Required</label>
                            <select style={{ width: '100%' }} value={whatsappApplicable} onChange={(e) => setWhatsappApplicable(e.target.value)} >
                                <option value="">Select</option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>
                        </div>
                    }
                    <div style={{ flex: '0 0 100%', display: 'flex', justifyContent: 'flex-end', gridGap: '10px' }}>
                        <button name='Search' onClick={handleSearch} style={{ alignItems: 'center', display: 'flex' }}><SearchIcon style={{ width: '.6em', height: 'unset', marginRight: '5px' }}></SearchIcon>Search</button>

                        {/* <button name="GP" disabled={actionButtonEnabled !== 'PF'} onClick={(e) => { onAction(e.target.name) }} style={{ alignItems: 'center', display: 'flex' }}><PictureAsPdfIcon style={{ width: '.6em', height: 'unset', marginRight: '5px' }}></PictureAsPdfIcon>Generate PDF</button> */}
                        <button name="SE" disabled={actionButtonEnabled !== 'PE'} onClick={(e) => { onAction(e.target.name) }} style={{ alignItems: 'center', display: 'flex' }}><AttachEmailIcon style={{ width: '.6em', height: 'unset', marginRight: '5px' }}></AttachEmailIcon>Send Email</button>
                        <button name="SW" disabled={actionButtonEnabled !== 'PW'} onClick={(e) => { onAction(e.target.name) }} style={{ alignItems: 'center', display: 'flex' }}><WhatsAppIcon style={{ width: '.6em', height: 'unset', marginRight: '5px' }}></WhatsAppIcon>Send WhatsApp</button>
                    </div>
                </div>

            </header>
            <div style={{ marginTop: '20px', borderRadius: '5px', border: 'solid 1px #e7e2e2' }}>
                {pageData && (
                    <div style={{ display: 'flex', alignContent: 'center', justifyContent: 'space-between', alignItems: 'center' }} className='tableHeader'>
                        <label className='labelHeading'>{noticeType === 'CC' ? 'Credit Card' : noticeType === 'LRNCC' ? 'LRN - Credit Card' : noticeType === 'SEC25CC' ? 'Section 25 - Credit Card' : noticeType === 'HL' ? 'Home Loan' : noticeType === 'PL' ? 'Personal Loan' : 'Credit Card'} Notices({pageData && pageData.length})</label>
                        <button onClick={onExport} style={{ alignItems: 'center', display: 'flex', margin: '5px' }}><FileDownloadIcon style={{ width: '.6em', height: 'unset', marginRight: '5px' }}></FileDownloadIcon>Export</button>
                    </div>
                )}
                {pageData && pageData.length > 0 ? (
                    <div className='wrapper' style={{ display: 'none' }}>
                        <div className='cardNews-parent'>
                            {pageData.map((item, idx) => (
                                <div className="cardNew">
                                    <div className="cardNew-header">
                                        <span>Notice #{item['SrNo']}</span>
                                        <div className="status">
                                            <span>WhatsApp: {item['WhatsApp Sent'] === 'X' ? <CheckIcon style={{ width: '.7em', color: 'green' }} /> : <ClearIcon style={{ width: '.7em', color: 'red' }} />}</span>
                                            <span>Email: {item['Email Sent'] === 'X' ? <CheckIcon style={{ width: '.7em', color: 'green' }} /> : <CheckIcon style={{ width: '.7em', color: 'green' }} />}</span>
                                        </div>
                                    </div>
                                    <div className="cardNew-body">
                                        {tableColumns.map((key, idx1) => (
                                            key.indexOf('Address') == -1 && key !== 'Account No' && key !== 'Amount Word' && key !== 'Bounce Date' && key !== 'Bounce Reason' && key !== 'Year' && key !== 'PDF Generated?' && key !== 'WhatsApp Required?' && key !== 'Email Required?' && key !== 'Product' && key !== 'Email' && key !== 'CLM Name' && key !== 'CLM No' && key !== 'WhatsApp Sent?' && key !== 'Email Sent?' &&
                                            <p><strong>{key}:</strong> {item[key]}</p>
                                        ))}
                                        {/* <p><strong>{item}:</strong> {item}</p>
                                        <p><strong>Mask Card:</strong> **** **** **** 1234</p>
                                        <p><strong>LOT:</strong> ABC123</p>
                                        <p><strong>Name:</strong> John Doe John Doe John Doe</p>
                                        <p><strong>Balance:</strong> $500.00</p>
                                        <p><strong>Mobile:</strong> +1234567890</p>
                                        <p><strong>Notice Date:</strong> 2025-05-01</p> */}
                                    </div>
                                </div>
                            ))}

                        </div>

                    </div>
                ) : (<div className='noDataDiv' style={{ display: 'none' }}>Notice not found, Please adjust the filters!</div>)}

                {pageData && pageData.length > 0 ? (
                    <table>
                        <thead>
                            <tr>
                                {tableColumns.map((item, idx) => (
                                    item.indexOf('Address') == -1 && item !== 'Year' && item !== 'Account No' && item !== 'Amount Word' && item !== 'Bounce Date' && item !== 'Bounce Reason' && item !== 'PDF Generated?' && item !== 'WhatsApp Required?' && item !== 'Email Required?' && item !== 'Product' && item !== 'Email' && item !== 'CLM Name' && item !== 'CLM No' && <th key={idx}>{item}</th>

                                ))}
                                <th>PDF</th>
                            </tr>

                        </thead>
                        <tbody>
                            {pageData.map((item, idx) => (
                                <tr className='trLineItem' style={{ cursor: 'default' }} key={idx} data={item}>
                                    {tableColumns.map((key, idx1) => (
                                        key.indexOf('Address') == -1 && key !== 'Year' && key !== 'Account No' && key !== 'Amount Word' && key !== 'Bounce Date' && key !== 'Bounce Reason' && key !== 'PDF Generated?' && key !== 'WhatsApp Required?' && key !== 'Email Required?' && key !== 'Product' && key !== 'Email' && key !== 'CLM Name' && key !== 'CLM No' && <td data-label={key} key={idx1}>
                                            {(key === 'PDF Generated?' || key === 'Email Sent?' || key === 'WhatsApp Sent?')
                                                ? (item[key] === 'X' ? <CheckIcon style={{ width: '.7em' }} /> : <ClearIcon style={{ width: '.7em' }} />)
                                                : item[key]}
                                        </td>
                                    ))}
                                    <td data-label="PDF" style={{ alignItems: 'center', verticalAlign: 'bottom', justifyContent: 'space-around', display: 'flex', borderBottom: 'none' }}>
                                        {(item["PDF Generated?"] === 'X'
                                            ? <FilePresentIcon style={{ width: '1em', cursor: 'pointer', color: '#0056b3' }} onClick={() => onViewPDF(item)} ></FilePresentIcon>
                                            : '')
                                        }


                                    </td>
                                </tr>

                            ))}

                        </tbody>
                    </table>
                ) : (<div className='noDataDiv'>Notice not found, Please adjust the filters!</div>)}
            </div>
        </div>
        <div>
            <ToastContainer></ToastContainer>
        </div>
    </div>
}
export default NoticeList;